import { Divider, Form, message } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { agentLogin } from "../../../api/auth";
import Clients from "../../../assets/agentLogin.svg";
import Background from "../../../assets/bg.svg";
import Error from "../../../assets/error.svg";
import LoginLayout from "../../../components/LoginLayout";
import Button from "../../../components/button";
import MemberModal from "../../../components/memberModal";
import Logo from "../../../assets/logo.svg";
import InputField from "../../../components/inputField";
import { handleAuthRedirect } from "../../../constants/utils";
import ReCAPTCHA from "react-google-recaptcha";

//local
// const RECAPTCHA_SITE_KEY = "6LdSpOkqAAAAAJLkQfWcUL6jPq8uWPL6rf9hJYgG";

//dev
const RECAPTCHA_SITE_KEY = "6LdxtekqAAAAAKbXbCSOfNTcpAT_M-pBjcKSDzWb";

const AgentLogin = () => {
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [isErrorModal, setIsErrorModal] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoader(true);
    const payload = {
      email: values.email,
      password: values.password,
    };
    try {
      const res = await agentLogin(payload);
      if (res) {
        setLoader(true);
        if (res?.access_token) {
          localStorage.setItem("accessToken", res?.access_token);
          localStorage.setItem("refreshToken", res?.refresh_token);
          localStorage.setItem("user", JSON.stringify(res?.agent));
          localStorage.setItem("id", res?.agent?._id);
          localStorage.setItem("Login", "Agent");
          navigate("/main/dashboard");
        } else if (res?.otp_token) {
          localStorage.setItem("otpToken", res?.otp_token);
          localStorage.setItem("Login", "Agent");
          navigate("/agent/otp");
        }
      } else {
        showErrorModal();
      }
    } catch (error) {
      message.error(error.message);
      showErrorModal();
    } finally {
      setLoader(false);
    }
  };

  const showErrorModal = () => {
    setIsErrorModal(true);
  };

  const NoClickHandler = () => {
    setIsErrorModal(false);
  };

  const hideModal = () => {
    setIsErrorModal(false);
  };

  useEffect(() => {
    const AdminLogin = localStorage.getItem("Login");
    const Token = localStorage.getItem("accessToken");
    if (AdminLogin && Token) {
      handleAuthRedirect(AdminLogin, navigate);
    }
  }, [navigate]);

  return (
    <div>
      <LoginLayout image={Clients} bg={Background}>
        <div className="relative">
          <div className="absolute w-5 h-5 bg-blue-500 rounded-full left-10 top-7" />
          <div className="absolute top-0 right-0 w-24 h-24 bg-blue-500 rounded-bl-full" />
        </div>

        <div className="min-h-screen flex items-center justify-center">
          <div className="mx-4 sm:mx-6 lg:mx-20 xl:mx-40 w-full max-w-md">
            <div className="flex justify-center">
              <Link to="https://insurancehive.com/">
                <img src={Logo} alt="logo" className="cursor-pointer" />
              </Link>
            </div>
            <div className="space-y-5">
              <p className="text-2xl sm:text-3xl lg:text-4xl text-center font-bold mt-5">
                Login to Agent Portal
              </p>
              <Form
                form={form}
                onFinish={onFinish}
                name="signin"
                layout="vertical"
              >
                <Form.Item
                  name="email"
                  rules={[
                    {
                      type: "email",
                      message: "The input is not valid e-mail!",
                    },
                    {
                      required: true,
                      message: "Please input your Email Address",
                    },
                  ]}
                  label={
                    <span className="text-xl font-bold">Email Address</span>
                  }
                >
                  <InputField
                    placeholder={"Write email address"}
                    name={"email"}
                    type={"text"}
                    inputType={"email"}
                  />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[
                    {
                      type: "password",
                      message: "The input is not valid Password!",
                    },
                    {
                      required: true,
                      message: "Please input your Password",
                    },
                  ]}
                  label={<span className="text-xl font-bold">Password</span>}
                >
                  <InputField
                    placeholder={"Type Password"}
                    name={"password"}
                    type={"password"}
                    inputType={"both"}
                  />
                </Form.Item>
                <Form.Item>
                  <ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} />
                </Form.Item>
                <div className="flex justify-between">
                  <Form.Item className="hover:cursor-pointer font-bold text-[#0F3CDB]">
                    <Link to={"/agent/forgot-password"}>
                      <p>Forgot Password?</p>
                    </Link>
                  </Form.Item>
                </div>
                <Form.Item>
                  <Button
                    title={"Login"}
                    type={"primary"}
                    loading={loader}
                    htmlType="submit"
                  />
                </Form.Item>
                <div className="px-6">
                  <Divider className="bg-[#C7D1D9] border" />
                </div>
                <Form.Item>
                  <Link to="/agent/registration">
                    <Button
                      title={"Don't have an account? Register Now"}
                      type={"secondary"}
                    />
                  </Link>
                </Form.Item>
                <Form.Item>
                  <Link to="/">
                    <Button title={"Back"} type={"secondary"} />
                  </Link>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>

        <div className="relative">
          <div className="absolute bottom-7 w-5 h-5 bg-blue-500 rounded-full left-10" />
          <div className="absolute right-0 bottom-0 w-24 h-24 bg-blue-500 rounded-tl-full" />
        </div>
      </LoginLayout>
      {isErrorModal && (
        <MemberModal
          image={Error}
          title={"Unable to login"}
          onCancel={hideModal}
          onOk={NoClickHandler}
        />
      )}
    </div>
  );
};

export default AgentLogin;
